import React, { useState } from "react";
import { PostFieldLabel, PlatformUsage } from "components/Posts/PostForm";
import { FIELDS, IG_STORY_TYPES } from "constants/PostFormFields";
import PostFieldError from "components/Posts/PostForm/PostFieldError/PostFieldError";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const StoryType = ({
  post,
  onChange,
  errors = {},
  className = "",
  platforms,
  selectedPlatform,
  disabled = false,
}) => {
  const [selected, setSelected] = useState(post[FIELDS.STORY_TYPE] || "story");

  let config = [
    {
      label: IG_STORY_TYPES.STORY.LABEL,
      value: IG_STORY_TYPES.STORY.VALUE,
    },
    {
      label: IG_STORY_TYPES.REEL.LABEL,
      value: IG_STORY_TYPES.REEL.VALUE,
    },
  ];

  const handleStoryTypeChange = (item) => {
    setSelected(item);
    onChange(item);
  };

  return (
    <div className={className}>
      <div className="flex items-center">
        <PostFieldLabel className="mb-2 mr-4 mt-2">Type</PostFieldLabel>
        <PlatformUsage
          platforms={platforms}
          field={FIELDS.STORY_TYPE}
          selectedPlatform={selectedPlatform}
        />
      </div>
      <Select
        value={selected}
        onValueChange={handleStoryTypeChange}
        disabled={disabled}
      >
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {config.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <PostFieldError
        className="mt-4"
        fields={[FIELDS.STORY_TYPE]}
        errors={errors}
      />
    </div>
  );
};

export default StoryType;
